import { ISocialNetworkRepository } from '../../../domain/repositories/social-network.repository.interface';

export class ReorderSocialNetworksUseCase {
  constructor(private readonly repository: ISocialNetworkRepository) {}

  public async execute(items: { id: string; displayOrder: number }[]): Promise<void> {
    return this.repository.reorder(items);
  }
}
